import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgCalendarXLarge(props: ISvgProps) {
	return (
		<svg width={61} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#CalendarXLarge_svg__a)">
				<g clipPath="url(#CalendarXLarge_svg__b)">
					<path
						d="M7.623 59.687h44.174c3.495 0 6.395-2.864 6.395-6.38V11.224c0-3.516-2.9-6.354-6.395-6.354h-6.292V1.484c0-.65-.518-1.172-1.166-1.172-.647 0-1.165.521-1.165 1.172V4.87H16.246V1.484c0-.65-.518-1.172-1.166-1.172-.647 0-1.165.521-1.165 1.172V4.87H7.623c-3.495 0-6.395 2.838-6.395 6.354v42.083c0 3.516 2.9 6.38 6.395 6.38Zm44.174-2.343H7.623c-2.214 0-4.065-1.81-4.065-4.037V20.755H55.86v32.552c0 2.227-1.851 4.037-4.065 4.037ZM7.623 7.214h6.292v3.333c0 .651.518 1.172 1.165 1.172s1.165-.521 1.165-1.172V7.214h26.929v3.333c0 .651.518 1.172 1.165 1.172s1.165-.521 1.165-1.172V7.214h6.292c2.214 0 4.065 1.783 4.065 4.01v7.187H3.558v-7.187c0-2.227 1.851-4.01 4.065-4.01Z"
						fill={props.primaryColor}
					/>
					<rect x={7.835} y={24.667} width={43.749} height={6} rx={3} fill={props.secondaryColor} />
					<rect x={7.835} y={34} width={43.749} height={6} rx={3} fill={props.secondaryColor} />
					<rect x={7.835} y={43.333} width={31.154} height={6} rx={3} fill={props.secondaryColor} />
				</g>
			</g>
			<defs>
				<clipPath id="CalendarXLarge_svg__a">
					<path fill="#fff" transform="translate(.71)" d="M0 0h60v60H0z" />
				</clipPath>
				<clipPath id="CalendarXLarge_svg__b">
					<path fill="#fff" transform="translate(.71)" d="M0 0h58v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgCalendarXLarge;
